<template>
  <div class="card_box">
    <Card>
      <div slot="title" class="titlebox">
        <span class="title">
          {{
          $t("label.AcceptanceSearch.AcceptanceApplication")
          }}
        </span>
        <Icon type="ios-create-outline" class="applyicon" />
      </div>
      <!-- 主表内容 -->
      <Form ref="formdata" :model="formdata" :rules="rules">
        <table class="form-table form-table-print">
          <!-- 基本信息 -->
          <tr>
            <th class="requiredIitm">{{ $t("label.Acceptance.AcceptanceNo") }}</th>
            <td>
              <Form-item prop="acceptanceId">
                <Input type="text" v-model="formdata.acceptanceId" readonly disabled="disabled" />
              </Form-item>
            </td>
            <th class="requiredIitm">{{ $t("label.Acceptance.AcceptanceID") }}</th>
            <td>
              <Form-item prop="applicantUserId">
                <Input type="text" v-model="formdata.applicantUserId" disabled="disabled" />
              </Form-item>
            </td>
            <th class="requiredIitm">{{ $t("label.Acceptance.AcceptorName") }}</th>
            <td>
              <Form-item prop="applicantUserName">
                <Input type="text" v-model="formdata.applicantUserName" disabled="disabled" />
              </Form-item>
            </td>
          </tr>
          <tr>
            <th class="requiredIitm">{{ $t("label.Acceptance.SupplierName") }}</th>
            <td>
              <Form-item prop="vendorName">
                <Input type="text" v-model="formdata.vendorName" disabled />
              </Form-item>
            </td>
            <th class="requiredIitm">
              {{ $t("label.Acceptance.AcceptanceMaterials") }}
              <Tooltip
                placement="left-start"
                :transfer="true"
                :maxWidth="480"
                :content="$t('label.Acceptance.Tips.Matter') +'\n' +$t('label.Acceptance.Tips.Services')"
              >
                <Icon type="ios-help-circle-outline" />
              </Tooltip>
            </th>
            <td>
              <ab-upload
                v-model="formdata.acceptanceFile"
                abPermission="w"
                :disabled="permission.TACCEPTANCEAPPLY.acceptanceFile!=='w'"
                :format="['pdf','xlsx','xls','doc','docx','ppt','pptx','ofd','jpg','png','jpeg','bmp']"
              ></ab-upload>
            </td>
            <th class="requiredIitm">{{ $t("label.Acceptance.Note") }}</th>
            <td>
              <Form-item
                prop="note"
                :rules="[
                  {
                    trigger: 'change',
                    validator: (rule, value, callback) => {
                      noteAcceptanceFile(
                        rule,
                        value,
                        callback
                      );
                    },
                  },
                ]"
              >
                <Input
                  type="text"
                  v-model="formdata.note"
                  :disabled="permission.TACCEPTANCEAPPLY.note!=='w'"
                />
              </Form-item>
            </td>
          </tr>
          <tr>
            <th class="requiredIitm">{{ $t("label.Acceptance.AcceptanceDept") }}</th>
            <td>
              <Form-item>
                <Input type="text" v-model="formdata.applyDepartmentName" disabled="disabled" />
              </Form-item>
            </td>
            <th class="requiredIitm">{{ $t("label.Acceptance.AcceptanceDate") }}</th>
            <td>
              <Form-item prop="applyData">
                <ab-date
                  :disabled="permission.TACCEPTANCEAPPLY.applyData!=='w'"
                  style="width: 100%"
                  v-model="formdata.applyData"
                  format="yyyy-MM-dd"
                ></ab-date>
              </Form-item>
            </td>
          </tr>
          <tr>
            <!-- 件名 -->
            <th class="requiredIitm">
              <span>{{ $t("label.Acceptance.caseName") }}</span>
            </th>
            <td colspan="6">
              <Form-item prop="caseName">
                <Input
                  type="text"
                  :disabled="permission.TACCEPTANCEAPPLY.caseName!=='w'"
                  v-model="formdata.caseName"
                />
              </Form-item>
            </td>
          </tr>
        </table>
      </Form>
      <!-- 明细表格部分 -->
      <Form ref="listForm" :rules="rule" :model="tableObj" class="form-table-th-margin">
        <Table style="margin-top: 15px" border :columns="columns" :data="tableObj.list">
          <!-- 品目 -->
          <template slot-scope="{ row, index }" slot="itemEntrustmentName">
            <FormItem :prop="`list.${index}.itemEntrustmentName`" :rules="rule.itemEntrustmentName">
              <Input type="text" v-model="tableObj.list[index].itemEntrustmentName" disabled />
            </FormItem>
          </template>
          <!-- 供应商名称 -->
          <!-- <template slot-scope="{ row, index }" slot="vendorName">
            <FormItem
              :prop="`list.${index}.vendorName`"
              :rules="rule.vendorName"
            >
              <Input
                type="text"
                v-model="tableObj.list[index].vendorName"
                disabled
              />
            </FormItem>
          </template>-->
          <!-- 验收总金额 -->
          <!-- <template slot-scope="{ row, index }" slot="acceptanceTotAmount">
            <FormItem :prop="`list.${index}.acceptanceTotAmount`" :rules="rule.acceptanceTotAmount">
              <InputNumber
                disabled
                :active-change="false"
                :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="value => value.replace(/\s?|(,*)/g, '')"
                :precision="2"
                style="width:100%;"
                :min="0"
                @on-change="numberchange($event,item.swgysList[row._index],0)"
                v-model="tableObj.list[index].acceptanceTotAmount"
              ></InputNumber>
            </FormItem>
          </template>-->
          <!-- 已验收金额 -->
          <template slot-scope="{ row, index }" slot="acceptanceYAmount">
            <FormItem :prop="`list.${index}.acceptanceYAmount`" :rules="rule.acceptanceYAmount">
              <InputNumber
                disabled
                :active-change="false"
                :formatter="
                  (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\s?|(,*)/g, '')"
                :precision="2"
                style="width: 100%"
                :min="0"
                @on-change="numberchange($event, item.swgysList[row._index], 0)"
                v-model="tableObj.list[index].acceptanceYAmount"
              ></InputNumber>
            </FormItem>
          </template>
          <!-- 未验收金额 -->
          <!-- <template slot-scope="{ row, index }" slot="acceptanceNAmount">
            <FormItem :prop="`list.${index}.acceptanceNAmount`" :rules="rule.acceptanceNAmount">
              <InputNumber
                disabled
                :active-change="false"
                :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="value => value.replace(/\s?|(,*)/g, '')"
                :precision="2"
                style="width:100%;"
                :min="0"
                @on-change="numberchange($event,item.swgysList[row._index],0)"
                v-model="tableObj.list[index].acceptanceNAmount"
              ></InputNumber>
            </FormItem>
          </template>-->
          <!-- 验收中金额 -->
          <template slot-scope="{ row, index }" slot="acceptanceAmountS">
            <FormItem>
              <InputNumber
                disabled
                :active-change="false"
                :formatter="
                  (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\s?|(,*)/g, '')"
                :precision="2"
                style="width: 100%"
                :min="0"
                @on-change="numberchange($event, item.swgysList[row._index], 0)"
                v-model="acceptanceAmountS[index]"
              ></InputNumber>
            </FormItem>
          </template>
          <!-- 验收金额 -->
          <template slot-scope="{ row, index }" slot="acceptanceAmount">
            <FormItem
              :prop="`list.${index}.acceptanceAmount`"
              :rules="[
                {
                  type: 'number',
                  trigger: 'change',
                  validator: (rule, value, callback) => {
                    numberValidator(
                      rule,
                      value,
                      callback,
                      row,
                      acceptanceAmountS[index]
                    );
                  },
                },
              ]"
            >
              <InputNumber
                :disabled="
                  permission.TACCEPTANCEAPPLYDETAIL.acceptanceAmount !== 'w'
                "
                :active-change="false"
                :formatter="
                  (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\s?|(,*)/g, '')"
                :precision="2"
                style="width: 100%"
                :min="0"
                v-model="tableObj.list[index].acceptanceAmount"
                :onkeyup="calculatePrice(tableObj.list[index])"
              ></InputNumber>
            </FormItem>
          </template>

          <!-- 备注 -->
          <template slot-scope="{ row, index }" slot="note">
            <FormItem :prop="`list.${index}.note`">
              <Input
                type="text"
                v-model="tableObj.list[index].note"
                :disabled="permission.TACCEPTANCEAPPLYDETAIL.note!=='w'"
              />
            </FormItem>
          </template>
          <!-- <template slot-scope="{ row, index }" slot="note">
            <FormItem
              :prop="`list.${index}.note`"
              :rules="[
                {
                  trigger: 'change',
                  validator: (rule, value, callback) => {
                    noteAcceptanceFile(rule, value, callback, row);
                  },
                },
              ]"
            >
              <Input
                type="text"
                v-model="tableObj.list[index].note"
                :disabled="permission.TACCEPTANCEAPPLYDETAIL.note !== 'w'"
              />
            </FormItem>
          </template>-->
          <!-- 验收材料证明 -->
          <!-- <template slot-scope="{ row, index }" slot="acceptanceFile">
            <ab-upload
              v-model="tableObj.list[index].acceptanceFile"
              abPermission="w"
              :disabled="
                permission.TACCEPTANCEAPPLYDETAIL.acceptanceFile !== 'w'
              "
            ></ab-upload>
          </template>-->
          <!-- 规格 -->
          <template slot-scope="{ row, index }" slot="specifications">
            <FormItem
              :prop="`list.${index}.specifications`"
              :rules="[{  trigger: 'change', validator:(rule,value,callback)=>{changeSpecifications(rule,index,tableObj.list[index].specifications,callback)}}]"
            >
              <Input
                type="text"
                v-model="tableObj.list[index].specifications"
                v-bind:disabled="tableObj.list[index].subjectServer==1 || permission.TACCEPTANCEAPPLYDETAIL.specifications !== 'w'"
              />
            </FormItem>
          </template>

          <!-- 期间 -->
          <template slot-scope="{ row, index }" slot="businessHoursEnd">
            <FormItem
              style="display: inline-block"
              :prop="`list.${index}.specifications`"
              :rules="[{  trigger: 'change', validator:(rule,value,callback)=>{changeDate(rule,tableObj.list[index].businessHoursStart,tableObj.list[index].businessHoursEnd,index,callback)}}]"
            >
              <ab-date
                style="width: 47%;"
                v-model="tableObj.list[index].businessHoursStart"
                format="yyyy-MM-dd"
                v-bind:disabled="tableObj.list[index].subjectObject==2 || permission.TACCEPTANCEAPPLYDETAIL.businessHoursStart !== 'w'"
              ></ab-date>
              <span>~</span>
              <ab-date
                style="width: 47%;"
                v-model="tableObj.list[index].businessHoursEnd"
                format="yyyy-MM-dd"
                v-bind:disabled="tableObj.list[index].subjectObject==2 || permission.TACCEPTANCEAPPLYDETAIL.businessHoursEnd !== 'w'"
              ></ab-date>
            </FormItem>

            <!-- <FormItem :prop="`list.${index}.businessHoursEnd`" :rules="rule.qijian" style="display:inline-block;">
             <ab-date
                style="width: 10%;display:inline;margin:0 0;padding:0 0;"
                v-model="tableObj.list[index].businessHoursEnd"
                format="yyyy-MM-dd"
              ></ab-date>          
            </FormItem>-->
          </template>

          <!-- 纳期 -->
          <template slot-scope="{ row, index }" slot="deliveryDeadline">
            <FormItem
              :prop="`list.${index}.deliveryDeadline`"
              :rules="[{  trigger: 'change',  validator:(rule,value,callback)=>{changeDate2(rule,tableObj.list[index].deliveryDeadline,index,callback)}}]"
            >
              <ab-date
                style="width: 100%"
                v-model="tableObj.list[index].deliveryDeadline"
                format="yyyy-MM-dd"
                v-bind:disabled="tableObj.list[index].subjectServer==1 || permission.TACCEPTANCEAPPLYDETAIL.deliveryDeadline !== 'w'"
              ></ab-date>
            </FormItem>
          </template>

          <!-- 数量 -->
          <template slot-scope="{ row, index }" slot="amount">
            <!-- edit fj 20211126 Start -->
            <FormItem :prop="`list.${index}.amount`" :rules="[{  trigger: 'change',  validator:(rule,value,callback)=>{changeAmount(rule,tableObj.list[index].amount,index,callback)}}]">
            <!-- edit fj 20211126 End -->
              <Input
                type="tel"
                v-model="tableObj.list[index].amount"
                :onkeyup="calculatePrice(tableObj.list[index])"
                :disabled="permission.TACCEPTANCEAPPLYDETAIL.amount !== 'w'
              "
              />
            </FormItem>
          </template>

          <!-- 单价 -->
          <template slot-scope="{ row, index }" slot="price">
            <FormItem :prop="`list.${index}.price`">
              <InputNumber
                style="width: 100%"
                :min="0"
                v-model="tableObj.list[index].price"
                disabled
              ></InputNumber>
            </FormItem>
          </template>

          <!-- 操作 -->
          <template slot-scope="{ row, index }" slot="remove">
            <FormItem>
              <Button type="error" @click="remove(index)" :disabled="detail">
                {{
                $t("label.Acceptance.Delete")
                }}
              </Button>
            </FormItem>
          </template>
        </Table>
      </Form>
    </Card>
  </div>
</template>
<script>
import util from "@/libs/util";
export default {
  data: function() {
    return {
      permission: {},
      detail: false,
      verdictApplyDepartment: "",
      department: [],
      acceptanceAmountS: [],
      swsubject: "",
      fwsubject: "",
      tableObj: {
        list: [
          {
            itemEntrustmentName: "",
            vendorName: "",
            //acceptanceTotAmount: "",
            acceptanceYAmount: "",
            //acceptanceNAmount: "",
            itemName: "",
            acceptanceAmount: "",
            note: "",
            acceptanceFile: "",
            amount: "",
            price: "",
            specifications: "",
            businessHoursStaryt: "",
            businessHoursEnd: "",
            deliveryDeadline: "",
            subjectServer: "",
            subjectObject: ""
          }
        ]
      },
      rules: {
        // acceptanceId: [
        //   {
        //     required: true,
        //     message: `${$t("label.Acceptance.AcceptanceNo")}不能为空`,
        //     trigger: "change"
        //   }
        // ],
        applicantUserId: [
          {
            required: true,
            message: util.getmsg(this, "label.Acceptance.AcceptanceID"),
            trigger: "change"
          }
        ],
        applicantUserName: [
          {
            required: true,
            message: util.getmsg(this, "label.Acceptance.AcceptorName"),
            trigger: "change"
          }
        ],
        applyDepartment: [
          {
            required: true,
            message: util.getmsg(this, "label.Acceptance.AcceptanceDept"),
            trigger: "change"
          }
        ],
        applyData: [
          {
            required: true,
            message: util.getmsg(this, "label.Acceptance.AcceptanceDate"),
            trigger: "change"
          }
        ],
        price: [
          {
            required: true,
            type: "number",
            message: util.getmsg(this, "label.Acceptance.price"),
            trigger: "change"
          }
        ],
        amount: [
          {
            required: true,
            message: util.getmsg(this, "label.Acceptance.amount"),
            trigger: "change"
          }
        ],
        caseName: [
          {
            required: true,
            message: util.getmsg(this, "label.Acceptance.caseName"),
            trigger: "change"
          }
        ]
      },
      columns: [
        {
          title: `${$t("label.Acceptance.No")}`,
          type: "index",
          width: 60,
          align: "center"
        },
        {
          title: `${$t("label.Acceptance.PhysicalService")}`,
          slot: "itemEntrustmentName",
          align: "center",
          width: 230,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.Acceptance.PhysicalService")
            );
          }
        },
        // {
        //   title: `${$t("label.Acceptance.SupplierName")}`,
        //   slot: "vendorName",
        //   align: "center",
        //   width: 250,
        //   renderHeader: (h, params) => {
        //     return h(
        //       "div",
        //       { class: "requiredIitm" },
        //       $t("label.Acceptance.SupplierName")
        //     );
        //   },
        // },

        // {
        //   title: `${$t("label.Acceptance.Total")}`,
        //   slot: "acceptanceTotAmount",
        //   align: "center",
        //   width: 200,
        //   renderHeader: (h, params) => {
        //     return h("div", {class:'requiredIitm'},$t("label.Acceptance.Total"))
        //   }
        // },
        {
          title: `${$t("label.Acceptance.AcceptedAmount")}`,
          slot: "acceptanceYAmount",
          align: "center",
          width: 160,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.Acceptance.AcceptedAmount")
            );
          }
        },
        // {
        //   title: `${$t("label.Acceptance.UnacceptedAmount")}`,
        //   slot: "acceptanceNAmount",
        //   align: "center",
        //   width: 200,
        //   renderHeader: (h, params) => {
        //     return h("div", {class:'requiredIitm'},$t("label.Acceptance.UnacceptedAmount"))
        //   }
        // },
        {
          title: `${$t("label.Acceptance.AmountInAcceptance")}`,
          slot: "acceptanceAmountS",
          align: "center",
          width: 160,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.Acceptance.AmountInAcceptance")
            );
          }
        },
        {
          title: `${$t("label.Acceptance.TotalAmount")}`,
          slot: "acceptanceAmount",
          align: "center",
          width: 160,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.Acceptance.TotalAmount")
            );
          }
        },
        //数量
        {
          title: `${$t("label.Acceptance.amount")}`,
          slot: "amount",
          align: "center",
          width: 120,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.Acceptance.amount")
            );
          }
        },
        //单价
        {
          title: `${$t("label.Acceptance.price")}`,
          slot: "price",
          align: "center",
          width: 160,
          renderHeader: (h, params) => {
            return h("div", {}, $t("label.Acceptance.price"));
          }
        },
        //规格
        {
          title: `${$t("label.Acceptance.specification")}`,
          slot: "specifications",
          align: "center",
          width: 230,
          renderHeader: (h, params) => {
            return h(
              "div",
              {},
              $t("label.Acceptance.specification") +
                $t("label.Acceptance.server")
            );
          }
        },
        //纳期
        {
          title: `${$t("label.Acceptance.deliveryDeadline")}`,
          slot: "deliveryDeadline",
          align: "center",
          width: 170,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.Acceptance.deliveryDeadline") +
                $t("label.Acceptance.server")
            );
          }
        },
        //期间
        {
          title: `${$t("label.Acceptance.period")}`,
          slot: "businessHoursEnd",
          align: "center",
          width: 330,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.Acceptance.period") + $t("label.Acceptance.object")
            );
          }
        },

        {
          title: `${$t("label.AcceptanceApplyDetail.Note")}`,
          slot: "note",
          align: "center",
          width: 230
        },

        // {
        //   title: `${$t("label.Acceptance.AcceptanceMaterials")}`,
        //   slot: "acceptanceFile",
        //   renderHeader: (h, params) => {
        //     return h("div", [
        //       h(
        //         "Tooltip",
        //         {
        //           props: {
        //             placement: "left-start",
        //             maxWidth: 800,
        //             transfer: true,
        //             content:
        //               $t("label.Acceptance.Tips.Matter") +
        //               "\n" +
        //               $t("label.Acceptance.Tips.Services")
        //           }
        //         },
        //         [
        //           $t("label.Acceptance.AcceptanceMaterials"),
        //           h("Icon", {
        //             props: {
        //               type: "ios-help-circle-outline"
        //             },
        //             style: {
        //               fontSize: "18px", // 改变icon的样式
        //               color: "#fff"
        //             }
        //           })
        //         ]
        //       )
        //       // h("Icon", {
        //       //   props: {
        //       //     type: "ios-help-circle-outline"
        //       //   },
        //       //   style: {
        //       //     fontSize: "18px", // 改变icon的样式
        //       //     color: "#fff",
        //       //     marginLeft:'5px'
        //       //   }
        //       // })
        //     ]);
        //   },
        //   align: "center",
        //   width: 200,
        // },
        {
          title: `${$t("label.Acceptance.Operation")}`,
          slot: "remove",
          align: "center",
          width: 110
        }
      ],
      rule: {
        itemEntrustmentName: [
          {
            required: true,
            message: util.getmsg(this, "label.Acceptance.PhysicalService"),
            trigger: "change"
          }
        ],
        vendorName: [
          {
            required: true,
            message: util.getmsg(this, "label.Acceptance.SupplierName"),
            trigger: "change"
          }
        ],
        // acceptanceTotAmount: [
        //   {
        //     required: true,
        //     type: "number",
        //     message: util.getmsg(this,'label.Acceptance.Total'),
        //     trigger: "change"
        //   }
        // ],
        itemName: [
          {
            required: true,
            message: util.getmsg(this, "label.Acceptance.AmountInAcceptance"),
            trigger: "change"
          }
        ],
        acceptanceAmount: [
          {
            required: true,
            type: "number",
            message: util.getmsg(this, "label.Acceptance.TotalAmount"),
            trigger: "change"
          }
        ],
        price: [
          {
            required: true,
            type: "number",
            message: util.getmsg(this, "label.Acceptance.price"),
            trigger: "change"
          }
        ],
        amount: [
          {
            required: true,
            message: util.getmsg(this, "label.Acceptance.amount"),
            trigger: "change"
          }
        ],
        deliveryDeadLine: [
          {
            required: true,
            message: util.getmsg(this, "label.Acceptance.deliveryDeadline"),
            trigger: "change"
          }
        ],
        caseName: [
          {
            required: true,
            message: util.getmsg(this, "label.Acceptance.caseName"),
            trigger: "change"
          }
        ]
      }
    };
  },
  props: {
    formdata: {
      //默认数据
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  created() {
    this.permission = this.$parent.permission.AcceptanceApplication;
    this.formdata.vendorName = this.formdata.TACCEPTANCEAPPLYDETAILList[0].vendorName;
    if (this.formdata.TACCEPTANCEAPPLYDETAILList !== null) {
      if (
        this.formdata.TACCEPTANCEAPPLYDETAILList.length > 0 &&
        this.formdata.TACCEPTANCEAPPLYDETAILList[0].verdictApplyDepartment !==
          null &&
        !this.formdata.flowStatus
      ) {
        this.formdata.applyDepartmentName = this.formdata.TACCEPTANCEAPPLYDETAILList[0].verdictApplyDepartment;
        this.formdata.applyDepartment = this.formdata.TACCEPTANCEAPPLYDETAILList[0].verdictApplyId;
      }
    }
    this.getDepartment(),
      (this.tableObj.list = this.formdata.TACCEPTANCEAPPLYDETAILList);

    if (!this.formdata.applyData) {
      this.$set(
        this.formdata,
        "applyData",
        this.moment(new Date()).format("YYYY-MM-DD")
      );
    }
    this.getAcceptanceAmount();
    this.detail = !this.$parent.instance
      ? false
      : this.$parent.instance.status === "end" ||
        this.$parent.instance.status === "running"
      ? true
      : this.$parent.instance.status === "draft"
      ? false
      : false ||
        this.$parent.flowRequestParam.extendConf ||
        this.$parent.flowRequestParam.extendConf.nodeId
      ? true
      : false;
    if (this.formdata.flowStatus == null) {
      if (this.detail == false) {
        for (var i = 0; i < this.tableObj.list.length; i++) {
          this.tableObj.list[i].acceptanceAmount = "";
          this.tableObj.list[i].price = "";
          if (
            this.tableObj.list[i].deliveryDeadline == null ||
            this.tableObj.list[i].deliveryDeadline == ""
          ) {
            if (
              this.tableObj.list[i].vendorId == "0S9" ||
              this.tableObj.list[i].vendorId == "0SA" ||
              this.tableObj.list[i].vendorId == "0SB" ||
              this.tableObj.list[i].vendorId == "0SC" ||
              this.tableObj.list[i].vendorId == "0ZZ"
            ) {
              this.tableObj.list[i].subjectServer = "0";
            } else {
              this.tableObj.list[i].subjectServer = "1";
            }
          } else {
            this.tableObj.list[i].subject = "0";
          }
          if (
            this.tableObj.list[i].businessHoursStart == null ||
            this.tableObj.list[i].businessHoursStart == ""
          ) {
            if (
              this.tableObj.list[i].vendorId == "0S9" ||
              this.tableObj.list[i].vendorId == "0SA" ||
              this.tableObj.list[i].vendorId == "0SB" ||
              this.tableObj.list[i].vendorId == "0SC" ||
              this.tableObj.list[i].vendorId == "0ZZ"
            ) {
              this.tableObj.list[i].subjectObject = "2";
            } else {
              this.tableObj.list[i].subjectObject = "2";
            }
          } else {
            this.tableObj.list[i].subject = "0";
          }
        }
      }
    }

    //   ? this.formdata.TACCEPTANCEAPPLYDETAILList
    //   : [];
  },
  methods: {
    // edit fj 20211126 Start
    //数量校验
    changeAmount(rule,value,index,callback){
      if(!value){
          callback(util.getmsg(this, "label.Acceptance.amount"));
        }else{
           callback();
        }
    },
    // edit fj 20211126 End
    //规格校验
    changeSpecifications(rule, index, value, callback) {
      if (this.tableObj.list[index].subjectServer == 1) {
        callback();
      } else {
        callback();
        // if (!value) {
        //   callback(util.getmsg(this, "label.Acceptance.specification"));
        // } else {
        //   callback();
        // }
      }
    },

    //计算单价
    calculatePrice(value) {
      var z = value.acceptanceAmount / value.amount;

      //保留2为小数
      var f = Math.round(z * 100) / 100;
      var s = f.toString();
      var rs = s.indexOf(".");
      if (rs < 0) {
        rs = s.length;
        s += ".";
      }
      while (s.length <= rs + 2) {
        s += "0";
      }
      if (
        value.amount == "" ||
        value.acceptanceAmount == "" ||
        value.amount == null
      ) {
        value.price = "";
      } else {
        if (!isNaN(value.amount)) {
          value.price = s;
        } else {
          value.amount = "";
          value.price = "";
        }
      }
    },
    //纳期校验
    changeDate2(rule, value, index, callback) {
      if (this.tableObj.list[index].subjectServer == 1) {
        callback();
      } else {
        if (!value) {
          callback(util.getmsg(this, "label.Acceptance.deliveryDeadline"));
        } else {
          callback();
        }
      }
    },
    //表单提交
    // formdata
    // formDynamic
    // formService

    async handleSubmit() {
      let validateflg = false;
      let flg = 0;
      this.$refs.formdata.validate(valid => {
        if (valid) {
          flg++;
        }
      });
      await this.$refs.listForm.validate(valid => {
        if (valid) {
          flg++;
        }
      });
      if (flg === 2) {
        if (this.tableObj.list.length > 0) {
          this.$parent.data.AcceptanceApplication.TACCEPTANCEAPPLYDETAILList = this.tableObj.list;
          var ids = new Array();
          for (var i = 0; i < this.tableObj.list.length; i++) {
            ids.push(
              this.formdata.TACCEPTANCEAPPLYDETAILList[i].verdictId +
                this.formdata.TACCEPTANCEAPPLYDETAILList[i].inquiryDetailId
            );
          }
          await this.abHttpUtil
            .post("/acceptanceSearch/getVerdictStatus?ids=" + ids, {})
            .then(res => {
              if (res == 0) {
                validateflg = true;
              } else {
                this.$Message.error($t("ERR.AcceptanceSearch.003"));
              }
            });
        } else {
          this.$Message.error($t("ERR.AcceptanceApply.004"));
        }
      } else {
        this.errmsg();
      }

      return validateflg;
    },
    //表格删除列
    remove(index) {
      if (this.tableObj.list.length > 1) {
        this.tableObj.list.splice(index, 1);
      }
    },
    //公用校验
    errmsg() {
      this.$nextTick(() => {
        var errMsg = [];
        var errList = document.querySelectorAll(".ivu-form-item-error-tip");
        errList.forEach(val => {
          if (errMsg.indexOf(val.innerHTML) == -1) {
            errMsg.push(val.innerHTML);
          }
        });
        errMsg.forEach(val => {
          this.$Message.error(val);
        });
      });
    },
    getDepartment() {
      this.abHttpUtil.post("/common/department", {}).then(res => {
        const data = res;
        data.forEach(item => {
          this.department.push(item);
        });
      });
    },
    //期间校验(判断是否为空,判断期间开始时间与期间结束时间大小)
    changeDate(rule, value1, value2, index, callback) {
      if (this.tableObj.list[index].subjectObject == 2) {
        callback();
      } else {
        var start = this.moment(value1)
          .format("YYYY-MM-DD")
          .replace(/-/g, "");
        var end = this.moment(value2)
          ? this.moment(value2)
              .format("YYYY-MM-DD")
              .replace(/-/g, "")
          : 999999999999999;
        if (!value1 || !value2) {
          callback(util.getmsg(this, "label.Acceptance.period"));
        } else if (start > end) {
          callback($t("ERR.AcceptanceApply.005"));
        } else {
          callback();
        }
      }
    },
    async numberValidator(rule, value, callback, row, number) {
      // await this.abHttpUtil
      //   .post(
      //     "/acceptanceApply/acceptanceInquiryDetailId?inquiryDetailId=" +
      //       row.inquiryDetailId +
      //       "&verdictId=" +
      //       row.verdictId,
      //     {}
      //   )
      //   .then(res => {
      //     row.acceptanceNAmount = res.rows[0].acceptanceNAmount;
      //   });
      if (!value) {
        callback(util.getmsg(this, "label.Acceptance.TotalAmount"));
        // } else if (value > row.acceptanceNAmount) {
        //   callback($t("ERR.AcceptanceApply.001"));
      } else {
        callback();
      }
    },
    // 验收理由 验收材料证明2选一
    noteAcceptanceFile(rule, value, callback) {
      if (
        !value &&
        (!this.formdata.acceptanceFile ||
          this.formdata.acceptanceFile === "[]") &&
        !this.formdata.note
      ) {
        callback($t("ERR.AcceptanceApply.002"));
      } else {
        callback();
      }
    },
    async getAcceptanceAmount() {
      for (var i = 0; i < this.tableObj.list.length; i++) {
        if (
          this.formdata.flowStatus == "2" ||
          this.formdata.flowStatus == "3"
        ) {
          await this.abHttpUtil
            .post(
              "/acceptanceApply/acceptanceInquiryDetailId?inquiryDetailId=" +
                this.formdata.TACCEPTANCEAPPLYDETAILList[i].inquiryDetailId +
                "&verdictId=" +
                this.formdata.TACCEPTANCEAPPLYDETAILList[i].verdictId,
              {}
            )
            .then(res => {
              if (res.rows[0].acceptanceAmount !== null) {
                this.$set(
                  this.acceptanceAmountS,
                  [i],
                  res.rows[0].acceptanceAmount
                );
              }
              if (res.rows[0].acceptanceNAmount !== null) {
                this.tableObj.list[i].acceptanceNAmount =
                  res.rows[0].acceptanceNAmount;
              }
              if (res.rows[0].acceptanceYAmount !== null) {
                this.tableObj.list[i].acceptanceYAmount =
                  res.rows[0].acceptanceYAmount;
              }
            });
        } else {
          this.acceptanceAmountS[i] = this.tableObj.list[i].acceptanceAmount;
        }
      }
    }
  }
};
</script>
